import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/Invoice/Invoice/src/components/Invoice/InvoiceShell.js");
